import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function DeanStudents() {

  const { classId } =
    useParams();

  const token =
    localStorage.getItem("access");

  const [students, setStudents] =
    useState([]);

  useEffect(() => {

    fetchStudents();

  }, []);

  const fetchStudents = async () => {

    try {

      const res = await axios.get(
        `https://api.eduskot.com/api/academics/dean/students/${classId}/`,
        {
          headers:{
            Authorization:
            `Bearer ${token}`
          }
        }
      );

      setStudents(res.data);

    } catch(err){

      console.error(err);
    }
  };

  return (

    <div style={styles.page}>

      <h1>
        Dean Students
      </h1>

      <table style={styles.table}>

        <thead>

          <tr>

            <th>Name</th>

            <th>Admission No</th>

            <th>Gender</th>

          </tr>

        </thead>

        <tbody>

          {students.map((s)=>(

            <tr key={s.id}>

              <td>
                {s.full_name}
              </td>

              <td>
                {s.admission_number}
              </td>

              <td>
                {s.gender}
              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
}

const styles = {

  page:{
    padding:"30px"
  },

  table:{
    width:"100%",
    borderCollapse:"collapse"
  }
};

export default DeanStudents;